module.exports = __webpack_public_path__ + "img/payment.5d568a8d.png";